import React from 'react';
import { Avatar, Box, Tooltip } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';

const baseURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

interface ClubLogoProps {
  clubId: string;
  hasLogo: boolean;
  size?: 'small' | 'medium' | 'large';
  tooltip?: string;
  withBorder?: boolean;
}

const ClubLogo: React.FC<ClubLogoProps> = ({ 
  clubId, 
  hasLogo, 
  size = 'medium',
  tooltip,
  withBorder = false
}) => {
  // Size mappings
  const dimensions = {
    small: { width: 32, height: 32 },
    medium: { width: 48, height: 48 },
    large: { width: 64, height: 64 }
  }[size];
  
  const iconSize = {
    small: 'small',
    medium: 'medium',
    large: 'large'
  }[size] as 'small' | 'medium' | 'large';
  
  if (!hasLogo) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', ...dimensions }}>
        <BusinessIcon color="primary" fontSize={iconSize} />
      </Box>
    );
  }
  
  const avatar = (
    <Avatar 
      src={`${baseURL}/api/images/Club/${clubId}/thumbnail`}
      alt="Club Logo"
      sx={{ 
        ...dimensions,
        bgcolor: 'primary.light',
        ...(withBorder && { border: '1px solid rgba(0,0,0,0.1)' })
      }}
      variant="rounded"
    >
      <BusinessIcon fontSize={iconSize} />
    </Avatar>
  );
  
  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        {avatar}
      </Tooltip>
    );
  }
  
  return avatar;
};

export default ClubLogo;